<template>
  <section>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      :can-cancel="false"
    >
      <div class="modal-card">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.user_id" class="modal-card-title">Crear Usuario</p>
          <p v-else class="modal-card-title">Editar Usuario</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="user.name"
              v-model="user.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Paterno">
            <b-input
              type="text"
              :value="user.pather_lastname"
              v-model="user.pather_lastname"
              placeholder="Apellido Paterno"
              required
            ></b-input>
          </b-field>
          <b-field label="Apellido Materno">
            <b-input
              type="text"
              :value="user.mother_lastname"
              v-model="user.mother_lastname"
              placeholder="Apellido Materno"
              required
            ></b-input>
          </b-field>
          <b-field label="Rut">
            <b-input
              type="text"
              :value="user.rut"
              v-model="user.rut"
              placeholder="RUT"
              required
            ></b-input>
          </b-field>
          <b-field label="Correo Electronico">
            <b-input
              type="email"
              :value="user.email"
              v-model="user.email"
              placeholder="Correo Electronico"
              required
            ></b-input>
          </b-field>
          <b-field label="Password" v-if="!this.user_id">
            <b-input
              type="password"
              :value="user.password"
              v-model="user.password"
              password-reveal
              placeholder="Password"
              required
            ></b-input>
          </b-field>
          <b-field label="Establecimiento">
            <b-select
              placeholder="Seleccionar Establecimiento"
              v-model="user.stablishment_id"
              expanded
            >
              <option
                v-for="stablishment in listStablishment"
                :value="stablishment.id"
                :key="stablishment.id"
              >
                {{ stablishment.name }}
              </option>
            </b-select>
          </b-field>
          <b-field label="Perfil">
            <b-select
              placeholder="Seleccionar Perfil"
              v-model="user.role_id"
              expanded
            >
              <option v-for="rol in listRoles" :value="rol.id" :key="rol.id">
                {{ rol.name }}
              </option>
            </b-select>
          </b-field>
          <div class="columns" v-if="!this.user_id">
            <div class="column is-9">
              <b-field label="Bodega">
                <b-select
                  placeholder="Seleccionar Bodega"
                  v-model="user.cellar_id"
                  expanded
                >
                  <option
                    v-for="cellar in listCellar"
                    :value="cellar.id"
                    :key="cellar.id"
                  >
                    {{ cellar.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-3">
              <b-button
                style="margin-top: 1.7em"
                @click="addCellar"
                type="is-primary"
                >Agregar Bodega</b-button
              >
            </div>
          </div>
          <div class="columns" v-else>
            <div class="column is-9">
              <b-field label="Bodega">
                <b-select
                  placeholder="Seleccionar Bodega"
                  v-model="user.cellar_id"
                  expanded
                >
                  <option
                    v-for="cellar in listCellar"
                    :value="cellar.id"
                    :key="cellar.id"
                  >
                    {{ cellar.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-3">
              <b-button
                style="margin-top: 1.7em"
                @click="addCellarEdit"
                type="is-primary"
                >Añadir Bodega</b-button
              >
            </div>
          </div>
          <b-table
            type="is-primary"
            :data.sync="selectedCellar"
            :is-fullwidth="true"
            v-if="!this.user_id"
          >
            <template slot-scope="props">
              <b-table-column field="profile" label="ID">{{
                props.row.id
              }}</b-table-column>
              <b-table-column field="profile" label="Bodega">{{
                props.row.name
              }}</b-table-column>

              <b-table-column field="delete" label="Eliminar">
                <b-button @click="deleteCellar(props.row.id)" type="is-danger"
                  >Eliminar</b-button
                >
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="frown-open" size="is-large"></b-icon>
                  </p>
                  <p>No hay perfiles ingresados</p>
                </div>
              </section>
            </template>
          </b-table>

          <b-table
            type="is-primary"
            :data.sync="selectedCellar"
            :is-fullwidth="true"
            v-else
          >
            <template slot-scope="props">
              <b-table-column field="profile" label="ID">{{
                props.row.id
              }}</b-table-column>
              <b-table-column field="profile" label="Bodega">{{
                props.row.cellar.name
              }}</b-table-column>

              <b-table-column field="delete" label="Eliminar">
                <b-button
                  @click="deleteCellarEdit(props.row.id)"
                  type="is-danger"
                  >Quitar</b-button
                >
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="frown-open" size="is-large"></b-icon>
                  </p>
                  <p>No hay perfiles ingresados</p>
                </div>
              </section>
            </template>
          </b-table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">
            Cerrar
          </button>
          <button
            v-if="!this.user_id"
            class="button is-primary"
            @click="createUser()"
          >
            Guardar
          </button>
          <button v-else class="button is-primary" @click="editUser()">
            Editar
          </button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
// import { storeCellarUser } from "@/services/user_cellar";
import {UserCellarService} from "../../../services/models/user_cellar"
import { UserService } from '../../../services/models/user';
import { StablishmentService } from '../../../services/models/stablishment';
import { CellarService } from '../../../services/models/cellar';

export default {
  props: ["isComponentModalActive", "closeBasic", "chargeListUser", "user_id"],
  data() {
    return {
      user: {
        name: "",
        pather_lastname: "",
        mother_lastname: "",
        rut: "",
        email: "",
        password: "",
        stablishment_id: "",
        role_id: "",
        stament_id: "",
        type_user_id: "",
        location_id: "",
        cellar_id: "",
      },
      selectedCellar: [],
      selectedProfilesOriginal: [],
      listCellar: [],
      listStablishment: [],
      listRoles: [
        { id: 1, name: "Administrador" },
        { id: 2, name: "Administrativo" },
        { id: 3, name: "Funcionario" },
      ],
      listStament: [],
      listUserType: [],
      listLocation: [],
      isLoading: false,
      filteredCellar: [],
    };
  },
  created: function () {
    this.isLoading = true;
    this.chargeLists().then(() => {
      if (this.user_id) {
        this.chargeUserData().then(() => {
          this.isLoading = false;
        });
      } else {
        this.isLoading = false;
      }
    });
  },
  methods: {
    deleteCellar(cellar_id) {
      console.log(cellar_id);
      this.selectedCellar = this.selectedCellar.filter(
        (profile) => profile.id != cellar_id
      );
    },
    async deleteCellarEdit(id) {
      this.isLoading = true;
      await UserCellarService.remove(id);
      this.toast("La bodega fue quitada", "is-warning");
      await this.chargeUserData();
      this.isLoading = false;

      // await this.$http
      //   .delete(`api/${localStorage.getItem("perfil")}/user_cellar/` + id)
      //   .then((response) => {
      //     console.log(response);
      //     this.toast("La bodega fue quitada", "is-warning");
      //   });
      // await this.chargeUserData();
      // this.isLoading = false;
    },
    addCellar() {
      let isCellarAdded = this.selectedCellar.find(
        (cellar) => cellar.id == this.user.cellar_id
      );
      if (!isCellarAdded) {
        let cellarName = this.listCellar.find(
          (est) => est.id == this.user.cellar_id
        ).name;
        this.selectedCellar.push({
          id: this.user.cellar_id,
          name: cellarName,
        });
      } else {
        this.toast("El usuario ya tiene asignado este perfil", "is-warning");
      }
    },
    async addCellarEdit() {
      let data = {
        user_id: this.user_id,
        cellar_id: this.user.cellar_id,
      };
      this.isLoading = true;
      await UserCellarService.create(data);
      // await storeCellarUser(this.$http, data);
      await this.chargeUserData();
      this.isLoading = false;
      this.toast("Agregada la bodega", "is-success");
    },
    getFilteredStablishments(text, role_index) {
      console.log(text);
      console.log(role_index);
      this.selectedCellar[role_index].filteredCellar = this.listCellar.filter(
        (option) => {
          return (
            option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >=
            0
          );
        }
      );
    },
    createUser: async function () {
      if (this.selectedCellar.length !== 0) {
        this.isLoading = true;
        let data = {
          ...this.user,
        };
        try {
          const {data : user} = await UserService.create(data);
          console.log(user)
          for (let i = 0; i < this.selectedCellar.length; i++) {
            await UserCellarService.create({
              user_id: user.id,
              cellar_id: this.selectedCellar[i].id,
            });
          }
          this.chargeListUser();
          this.closeBasic();
          this.toast("Creado el usuario", "is-success");
        } catch (error) {
          this.toast("error al crear", "is-danger");
          console.log("error: ", error);
        }
        this.isLoading = false;

        // await this.$http
        //   .post(`api/${localStorage.getItem("perfil")}/user`, data)
        //   .then(
        //     async (response) => {
        //       for (let i = 0; i < this.selectedCellar.length; i++) {
        //         await storeCellarUser(this.$http, {
        //           user_id: response.body.user.id,
        //           cellar_id: this.selectedCellar[i].id,
        //         });
        //       }
        //       //Limpia el objeto User
        //       for (const i in this.user) {
        //         this.user[i] = "";
        //       }
        //       console.log("POST:", response.body);
        //       this.chargeListUser();
        //       this.closeBasic();
        //       this.toast("Creado el usuario", "is-success");
        //       this.isLoading = false;
        //     },
        //     (response) => {
        //       this.toast("error al crear", "is-danger");
        //       this.isLoading = false;
        //       console.log("error: ", response);
        //     }
        //   );
      } else {
        this.toast("No hay perfiles seleccionados", "is-warning");
      }
    },
    editUser: async function () {
      this.isLoading = true;
      try {
        await UserService.update( this.user_id,this.user);
        this.chargeListUser();
        this.closeBasic();
        this.toast("Editado el usuario", "is-success");
      } catch (error) {
        this.toast("Error al editar", "is-danger");
      }
      this.isLoading = false;

      // this.isLoading = true;
      // let data = {
      //   ...this.user,
      // };
      // this.$http
      //   .put(`api/${localStorage.getItem("perfil")}/user/` + this.user_id, data)
      //   .then(
      //     (response) => {
      //       //Limpia el objeto User
      //       for (const i in this.user) {
      //         this.user[i] = "";
      //       }
      //       console.log("PUT:", response.body);
      //       this.chargeListUser();
      //       this.closeBasic();
      //       this.toast("Editado el Usuario", "is-success");
      //       this.isLoading = false;
      //     },
      //     (response) => {
      //       this.toast("error al editar", "is-danger");
      //       this.isLoading = false;
      //       console.log("error: ", response);
      //     }
      //   );
    },
    chargeLists: async function () {
      const {data: stablishments} = await StablishmentService.getAll();
      this.listStablishment = stablishments.data;
      const {data: cellars} = await CellarService.getAll();
      this.listCellar = cellars.data;
    },
    chargeUserData: async function () {
      const {data: user} = await UserService.getById(this.user_id);
      console.log(user);
      let userSelected = user[0]
      console.log(userSelected);
      this.user.name = userSelected.name
      this.user.pather_lastname = userSelected.pather_lastname
      this.user.mother_lastname = userSelected.mother_lastname
      this.user.rut = userSelected.rut
      this.user.email = userSelected.email
      this.user.password = userSelected.password
      this.user.stablishment_id = userSelected.stablishment_id
      this.user.role_id = userSelected.role_id
      this.selectedCellar = userSelected.users_cellars
      // await this.$http
      //   .get(`api/${localStorage.getItem("perfil")}/user/` + this.user_id)
      //   .then(
      //     (response) => {
      //       (this.user.name = response.body.data[0].name),
      //         (this.user.pather_lastname =
      //           response.body.data[0].pather_lastname),
      //         (this.user.mother_lastname =
      //           response.body.data[0].mother_lastname),
      //         (this.user.rut = response.body.data[0].rut),
      //         (this.user.email = response.body.data[0].email),
      //         (this.user.password = response.body.data[0].password),
      //         (this.user.stablishment_id =
      //           response.body.data[0].stablishment_id),
      //         (this.user.role_id = response.body.data[0].role_id),
      //         (this.selectedCellar = response.body.data[0].users_cellars);
      //     },
      //     (response) => {
      //       console.log(response);
      //     }
      //   );
    },
  },
};
</script>